import { actionTypes } from 'actions/actionTypes'
import type { CheckoutActionCreator } from 'routes/Checkout/models/ReduxTypes'

export const saveGooglePay3dsTransactionComplete: CheckoutActionCreator = (
  isGooglePay3dsTransactionComplete: boolean,
) => ({
  type: actionTypes.GOOGLE_PAY_STORE_3DS,
  isGooglePay3dsTransactionComplete,
})
